import React, { useState, useEffect } from 'react'
import { useAuth } from '../../hooks/useAuth'
import LoginForm from './LoginForm'
import InviteRegisterForm from './InviteRegisterForm'

interface InvitePageProps {
  inviteCode: string
}

const InvitePage: React.FC<InvitePageProps> = ({ inviteCode }) => {
  const [mode, setMode] = useState<'loading' | 'login' | 'register'>('loading')
  const [inviteInfo, setInviteInfo] = useState<any>(null)
  const { user } = useAuth()

  useEffect(() => {
    const loadInviteInfo = async () => {
      // TODO: Implementar carga real de información de invitación desde Firebase
      // Por ahora, no mostrar información simulada
      
      try {
        // En lugar de datos simulados, verificar si existe la invitación real
        // const inviteDoc = await getDoc(doc(db, 'invitations', inviteCode))
        // if (inviteDoc.exists()) {
        //   setInviteInfo(inviteDoc.data())
        // }
        
        // Por ahora, simplemente verificar si el usuario está logueado
        
        // Si el usuario ya está logueado, ir directo al login/registro
        if (user) {
          // Usuario logueado: procesar invitación directamente
          console.log('User already logged in, can process invite directly')
          setMode('login') // O redirigir a procesamiento de invitación
        } else {
          // Usuario no logueado: mostrar login
          setMode('login')
        }
        
      } catch (error) {
        console.error('Error loading invite:', error)
        setMode('login') // Fallback a login si hay error
      }
    }

    loadInviteInfo()
  }, [inviteCode, user])

  const handleSwitchToRegister = () => {
    setMode('register')
  }

  const handleSwitchToLogin = () => {
    setMode('login')
  }

  if (mode === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
              <p className="mt-2 text-gray-600 dark:text-gray-300">
                Cargando invitación...
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Comentado temporalmente - mostrar datos simulados de invitación
  // TODO: Implementar lógica real de invitación con datos de Firebase
  /*
  if (user) {
    // Si el usuario ya está logueado, mostrar opción de aceptar invitación
    return (
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                ¡Has sido invitado!
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                {inviteInfo?.invitedBy} te invita a unirte a "{inviteInfo?.caseName}"
              </p>
              
              {inviteInfo?.message && (
                <div className="mb-6 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                  <p className="text-sm text-blue-800 dark:text-blue-200">
                    💌 {inviteInfo.message}
                  </p>
                </div>
              )}

              <div className="space-y-3">
                <button
                  onClick={async () => {
                    // Aquí implementarías la lógica para aceptar la invitación
                    console.log('Accepting invite for logged in user')
                  }}
                  className="w-full btn btn-primary px-4 py-2"
                >
                  Aceptar Invitación
                </button>
                
                <button
                  onClick={() => {
                    // Redirigir al dashboard principal
                    window.location.href = '/'
                  }}
                  className="w-full btn btn-secondary px-4 py-2"
                >
                  Ir al Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  */

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        
        {/* Información de la invitación - Comentado hasta implementar datos reales */}
        {/* {inviteInfo && (
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-6 text-white text-center">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold mb-1">
              Invitación para unirse
            </h3>
            <p className="text-sm opacity-90">
              {inviteInfo.caseName}
            </p>
            <p className="text-xs opacity-75 mt-2">
              Por {inviteInfo.invitedBy}
            </p>
          </div>
        )} */}

        {/* Formulario de Login o Registro */}
        {mode === 'login' ? (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                Inicia Sesión
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                Inicia sesión para aceptar la invitación
              </p>
            </div>
            
            <LoginForm 
              onSwitchToRegister={handleSwitchToRegister} 
              inviteCode={inviteCode} // Pasar el código para procesarlo después del login
            />
          </div>
        ) : (
          <InviteRegisterForm 
            inviteCode={inviteCode}
            onBack={handleSwitchToLogin}
          />
        )}

        {/* Opciones para cambiar entre Login y Registro */}
        <div className="text-center">
          {mode === 'login' ? (
            <div className="text-sm text-gray-600 dark:text-gray-400">
              ¿No tienes cuenta?{' '}
              <button
                onClick={handleSwitchToRegister}
                className="text-primary hover:text-primary/80 font-medium"
              >
                Regístrate aquí
              </button>
            </div>
          ) : (
            <div className="text-sm text-gray-600 dark:text-gray-400">
              ¿Ya tienes cuenta?{' '}
              <button
                onClick={handleSwitchToLogin}
                className="text-primary hover:text-primary/80 font-medium"
              >
                Inicia sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default InvitePage 